export default {
  async orderById(orders, id) {
    return orders.filter((order) => order.financing_id === id);
  },
};
